import React from 'react';
import { useHistory } from 'react-router-dom';
import { CButton } from '@coreui/react';
import Parametros from './parametros';
import '../../scss/styles-infra.scss';

/** Cliente novo: os mesmos blocos da tela de configurações. */
const PipelineForm = () => {
    const history = useHistory();

    return (
        <div className="infra-container infra-container-rolavel">
            <div className="infra-cabecalho">
                <div>
                    <h4 className="infra-titulo">Novo cliente</h4>
                    <div className="infra-subtitulo">
                        <span>O pipeline nasce em rascunho: nada é executado até você mandar.</span>
                    </div>
                </div>
                <div className="infra-acoes-topo">
                    <CButton color="secondary" variant="outline" onClick={() => history.push('/infra')}>
                        Voltar
                    </CButton>
                </div>
            </div>

            <Parametros onCriado={id => history.push('/infra/pipeline/' + id)} />
        </div>
    );
};

export default PipelineForm;
